import { render, staticRenderFns } from "./GroupBuySettingManage.vue?vue&type=template&id=d9cdca60&scoped=true"
import script from "./GroupBuySettingManage.vue?vue&type=script&lang=js"
export * from "./GroupBuySettingManage.vue?vue&type=script&lang=js"
import style0 from "./GroupBuySettingManage.vue?vue&type=style&index=0&id=d9cdca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cdca60",
  null
  
)

export default component.exports